import * as constants from "../utils/constants";

export const setLoading = data => ({
    type: constants.SET_LOADING,
    payload: data
})
